import { render, staticRenderFns } from "./resumeForm.vue?vue&type=template&id=f33f9a2c&scoped=true"
import script from "./resumeForm.vue?vue&type=script&lang=js"
export * from "./resumeForm.vue?vue&type=script&lang=js"
import style0 from "./resumeForm.vue?vue&type=style&index=0&id=f33f9a2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33f9a2c",
  null
  
)

export default component.exports